<template>
  <div style="background-color: #f0f2f5">
    <v-col cols="10" offset="1">
      <h2 class="ma-5 text-center app--text">
        Choose a community from the ones below
      </h2>
      <groups-skeleton v-if="groups.length === 0" />
      <v-row v-if="groups">
        <v-col cols="3" v-for="group in groups" :key="group.id">
          <GroupCard :group="group" />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'Groups',
  components: {
    GroupCard: () => import('@/components/groups/groupCard.vue'),
    GroupsSkeleton: () => import('@/components/groups/groupsSkeleton.vue'),
  },
  computed: {
    groups() {
      return this.$store.state.groups.groups;
    },
  },
  created() {
    this.$store.dispatch('groups/loadGroups');
  },
  mounted() {
    console.log(this.groups);
  },
};
</script>

